var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.title)+" "),(_vm.showVisibility)?_c('span',[_vm._v("(sichtbar für "+_vm._s(_vm.visibility)+")")]):_vm._e()]),_vm._t("default")],2),(_vm.$slots.action)?_c('v-list-item-action',[_vm._t("action")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }